// API layer - chamadas HTTP com Request.*
// Docs/versões: axios via Request util do projeto; padrão Request.get/post/patch
// Endpoints (back-end ASP.NET Core 8):
//  POST   /trade-in-simulations
//  GET    /trade-in-simulations
//  PATCH  /trade-in-simulations/{id}/status

import Request from 'utils/request.js';
const BASE = '/trade-in-simulations';

const create = async (payload) => {
  // payload:
  // {
  //   fullName, phoneNumber, email,
  //   device, capacity, color, batteryHealth,
  //   usageOrBroken, malfunctions, paymentMethod
  // }
  const { data } = await Request.post(`${BASE}`, payload);
  return data; // pode vir vazio (201 Created). sucesso é status 201.
};

const getAll = async () => {
  const { data } = await Request.get(`${BASE}`);
  return data; // TradeInSimulationResponse[]
};

const updateStatus = async (id, status) => {
  // status: "Solicitado" | "Atendido" | "Finalizado"
  const { data } = await Request.patch(`${BASE}/${id}/status`, { status });
  return data; // Guid (id) no back; não é obrigatório usar aqui
};

export default {
  create,
  getAll,
  updateStatus,
};
